export default {
  'non_field_errors: [ Not enough money on your account to create an order ]':
    'Превышен кредитный лимит, пополните баланс лицевого счёта',
  'buyer: [ User has late payments ]': 'У вас есть просроченный платёж, пожалуйста оплатите и попробуйте снова.',
  'No user credentials': 'Неверный логин или пароль',
  'phone_number: [ Phone number is already verified. ]': 'Номер телефона уже был подтверждён',
}
